import { Col, Form, Row } from 'react-bootstrap';
import { ButtonContainer, StyledButton } from '../../StyledComponets';
import { allowOnlyNumbers, contactType } from '../constant';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  OTR_CNT_KEY,
  formatPhoneNumber,
  getOtherContactInitailValues,
  getOtherContactScheme,
} from './helpers';
import { useEffect, useState } from 'react';
import {
  fetchCityState,
  getCityStateByZip,
} from '../../app/contact/contactSlice';
import { useDispatch, useSelector } from 'react-redux';
export default function ContactForm(props) {
  const { type, pageType, showCommonForm, saveContact, formData } = props;
  const [disableFields, setDisableFileds] = useState(false);
  const [saveClicked, setSaveClicked] = useState(0);

  const isView = pageType === 'view';
  const isEdit = pageType === 'edit';

  const {
    register,
    watch,
    handleSubmit,
    trigger,
    setValue,
    getValues,
    setFocus,
    reset,
    setError,
    clearErrors,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(getOtherContactScheme(props.type)),
    defaultValues: formData || getOtherContactInitailValues,
  });
  const dispatch = useDispatch();
  const cityState = useSelector(getCityStateByZip);

  const renderError = (key) =>
    errors?.[key]?.message && (
      <Form.Control.Feedback type="invalid">
        {errors?.[key]?.message}
      </Form.Control.Feedback>
    );

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
  
    useEffect(() => {
      if (isValid) {
        saveContact(getValues());
      }
    }, [saveClicked]);
  
   
  useEffect(() => {
    if (getValues(OTR_CNT_KEY.ZIP)?.length === 5) {
      if (cityState?.validZip) {
        setValue(OTR_CNT_KEY.VALIDZIP, true);
        setValue(OTR_CNT_KEY.STATE, cityState?.state);
        setValue(OTR_CNT_KEY.CITY, cityState?.city);
        clearErrors([
          OTR_CNT_KEY.ZIP,
          OTR_CNT_KEY.VALIDZIP,
          OTR_CNT_KEY.STATE,
          OTR_CNT_KEY.CITY,
        ]);
      } else {
        setValue(OTR_CNT_KEY.VALIDZIP, false);
        cityState && setError(OTR_CNT_KEY.ZIP, { message: 'Enter valid zip' });
        setValue(OTR_CNT_KEY.STATE, '');
        setValue(OTR_CNT_KEY.CITY, '');
      }
    }
  }, [cityState]);

  const mobileField = register(OTR_CNT_KEY.MOBILE, { required: true });
  const onMobileChange = (e) => {
    const value = allowOnlyNumbers(e.target.value);
    e.target.value = formatPhoneNumber(value);
    mobileField.onChange(e);
  };

  const zipField = register(OTR_CNT_KEY.ZIP, { required: true });
  const onZipChange = (e) => {
    const value = e.target.value;
    e.target.value = allowOnlyNumbers(value);
    if (e.target.value.length < 5) {
      setValue(OTR_CNT_KEY.VALIDZIP, true);
      clearErrors([OTR_CNT_KEY.VALIDZIP]);
    } else {
      onZipBlur(e);
    }
    setValue(OTR_CNT_KEY.STATE, '');
    setValue(OTR_CNT_KEY.CITY, '');
    zipField.onChange(e);
  };

  const onZipBlur = (e) => {
    if (e.target.value.length === 5) {
      dispatch(fetchCityState(e.target.value));
    }
  };

  const resetCommonFields = () => {
    reset(getOtherContactInitailValues);
  };

  const renderAddressForm = (add1, add2, st, city, zip) => (
    <>
      <Row>
        <Col>
          <Form.Group controlId="addr1">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              Address Line1
            </Form.Text>
            <Form.Control
              {...register(add1)}
              type="text"
              placeholder="Enter Address Line1"
              maxLength="100"
              isInvalid={errors[add1]}
              disabled={disableFields || isView}
            />
            {renderError(add1)}
          </Form.Group>
        </Col>
        <Col>
          <Form.Group controlId="addr2">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              Address Line2 (optional)
            </Form.Text>
            <Form.Control
              {...register(add2)}
              type="text"
              placeholder="Enter Address Line2"
              maxLength="100"
              isInvalid={errors[add2]}
              disabled={disableFields || isView}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Group controlId="city">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              City
            </Form.Text>
            <Form.Control
              {...register(city)}
              type="text"
              placeholder="Enter City"
              disabled={true}
              isInvalid={errors[city]}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group controlId="state">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              State
            </Form.Text>
            <Form.Control
              {...register(st)}
              type="text"
              placeholder="Enter State"
              disabled={true}
              isInvalid={errors[st]}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group controlId="zip">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              Zip
            </Form.Text>
            <Form.Control
              {...zipField}
              type="text"
              maxLength="5"
              autoComplete="nope"
              placeholder="Enter Zipcode"
              onChange={onZipChange}
              isInvalid={errors[zip]}
              disabled={disableFields || isView}
            />
            {renderError(zip)}
          </Form.Group>
        </Col>
      </Row>
    </>
  );

  const renderCommonForm = () => (
    <>
      <Row>
        <Col>
          <Form.Group controlId="firstname">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              First Name
            </Form.Text>
            <Form.Control
              {...register(OTR_CNT_KEY.FNAME)}
              type="text"
              placeholder="First name"
              maxLength="100"
              isInvalid={errors[OTR_CNT_KEY.FNAME]}
              disabled={disableFields || isView}
            />
            {renderError(OTR_CNT_KEY.FNAME)}
          </Form.Group>
        </Col>
        <Col>
          <Form.Group controlId="lastname">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              Last Name
            </Form.Text>
            <Form.Control
              {...register(OTR_CNT_KEY.LNAME)}
              type="text"
              placeholder="Last name"
              maxLength="100"
              isInvalid={errors[OTR_CNT_KEY.LNAME]}
              disabled={disableFields || isView}
            />
            {renderError(OTR_CNT_KEY.LNAME)}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Form.Group controlId="companyName">
          <Form.Text size="sm" style={{ margin: '2px' }}>
            Company Name {type !== contactType.installer ? `(optional)` : ``}
          </Form.Text>
          <Form.Control
            {...register(OTR_CNT_KEY.CPNAME)}
            type="text"
            placeholder="Company name"
            maxLength="100"
            isInvalid={errors[OTR_CNT_KEY.CPNAME]}
            disabled={disableFields || isView}
          />
          {renderError(OTR_CNT_KEY.CPNAME)}
        </Form.Group>
      </Row>
      <Row>
        <Col>
          {' '}
          <Form.Group controlId="email">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              Email
            </Form.Text>
            <Form.Control
              {...register(OTR_CNT_KEY.EMAIL)}
              type="text"
              placeholder="Email id"
              maxLength="100"
              isInvalid={errors[OTR_CNT_KEY.EMAIL]}
              disabled={disableFields || isView}
            />
            {renderError(OTR_CNT_KEY.EMAIL)}
          </Form.Group>
        </Col>
        <Col>
          <Form.Group controlId="mbl">
            <Form.Text size="sm" style={{ margin: '2px' }}>
              Mobile No
            </Form.Text>
            <Form.Control
              {...mobileField}
              type="text"
              placeholder="Mobile number"
              autoComplete="nope"
              maxLength={14}
              isInvalid={errors[OTR_CNT_KEY.MOBILE]}
              onChange={onMobileChange}
              disabled={disableFields || isView}
            />
            {renderError(OTR_CNT_KEY.MOBILE)}
          </Form.Group>{' '}
        </Col>
      </Row>
      {renderAddressForm(
        OTR_CNT_KEY.ADD1,
        OTR_CNT_KEY.ADD2,
        OTR_CNT_KEY.STATE,
        OTR_CNT_KEY.CITY,
        OTR_CNT_KEY.ZIP
      )}
    </>
  );

  return (
    <Form key={type}>
      {showCommonForm && renderCommonForm()}
      <ButtonContainer>
        <StyledButton
          btnType="secondary"
          variant="dark"
          size="md"
          onClick={() => {
            resetCommonFields();
          }}
        >
          Reset
        </StyledButton>
        <StyledButton
          key="modalBtn"
          onClick={async () => {
            await trigger();
            setSaveClicked(() => saveClicked + 1);
          }}
          btnType="primary"
          variant="dark"
          size="md"
        >
          Save
        </StyledButton>
      </ButtonContainer>
    </Form>
  );
}
